import { AdvancedSearchEntityType } from "generated/graphql";
import React from "react";
import { Link } from "react-router-dom";

interface EntityLinkProps {
    entityType: AdvancedSearchEntityType;
    entityId: string;
}

export const EntityLink: React.FC<EntityLinkProps> = props => {
    const { entityType, entityId } = props;

    switch (entityType) {
        case AdvancedSearchEntityType.Client:
            return <Link to={`/clients/show/${entityId}`}>View</Link>;
        case AdvancedSearchEntityType.Community:
        case AdvancedSearchEntityType.CommunityContact:
            return <Link to={`/communities/show/${entityId}`}>View</Link>;
        case AdvancedSearchEntityType.ReferenceContact:
            return <Link to={`/references/contacts/show/${entityId}`}>View</Link>;
        case AdvancedSearchEntityType.ReferenceBusiness:
            return <Link to={`/references/organizations/show/${entityId}`}>View</Link>;
    }

    return null;
};
